<ion-header no-border>
    <ion-toolbar class="grid-padding">
        <ion-title>Privacy Policy</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="on-the-way">
        <div class="container">
            <div class="WordSection1">
                <h1
                    style="
                        padding-top: 2pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Privacy Policy AB Connect
                </h1>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    AB Texel Group built the AB-Connect app as a Free app. This
                    SERVICE is provided by AB Texel Group at no cost and is
                    intended for use as is.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 150%;
                        text-align: left;
                    "
                >
                    This page is used to inform visitors regarding our policies
                    with the collection, use, and disclosure of Personal
                    Information if anyone decided to use our Service.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    If you choose to use our Service, then you agree to the
                    collection and use of information in relation to this
                    policy. The Personal Information that we collect is used for
                    providing and improving the Service. We will not use or
                    share your information with anyone except as described in
                    this Privacy Policy.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    The terms used in this Privacy Policy have the same meanings
                    as in our Terms and Conditions, which is accessible at
                    AB-Connect unless otherwise defined in this Privacy Policy.
                </p>
                <h2
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Information Collection and Use
                </h2>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    For a better experience, while using our Service, we don’t
                    require you to provide us with certain personally
                    identifiable information. We only need your phone number to
                    successfully log in on your account. The personal
                    information we use in the app comes from the organization
                    wide used payroll system AFAS. With the app we provide the
                    user with recent news, (work)instructions, events, payslips
                    and monthly worked hours. The information that we request
                    will be retained by us and used as described in this privacy
                    policy.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 265%;
                        text-align: left;
                    "
                >
                    The app does use third party services that may collect
                    information used to identify you. Link to privacy policy of
                    third party service providers used by the app
                </p>
                <ul id="l1">
                    <li data-list-text="">
                        <p
                            class="s1"
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                line-height: 12pt;
                                text-align: left;
                            "
                        >
                            Google Play Services
                        </p>
                    </li>
                </ul>
                <h2
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Log Data
                </h2>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    We want to inform you that whenever you use our Service, in
                    a case of an error in the app we collect data and
                    information (through third party products) on your phone
                    called Log Data. This Log Data may include information such
                    as your device Internet Protocol (“IP”) address, device
                    name, operating system version, the configuration of the app
                    when utilizing our Service, the time and date of your use of
                    the Service, and other statistics.
                </p>
                <h2
                    style="
                        padding-top: 3pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Cookies
                </h2>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    Cookies are files with a small amount of data that are
                    commonly used as anonymous unique identifiers. These are
                    sent to your browser from the websites that you visit and
                    are stored on your device&#39;s internal memory.
                </p>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    This Service does not use these “cookies” explicitly.
                    However, the app may use third party code and libraries that
                    use “cookies” to collect information and improve their
                    services. You have the option to either accept or refuse
                    these cookies and know when a cookie is being sent to your
                    device. If you choose to refuse our cookies, you may not be
                    able to use some portions of this Service.
                </p>
                <h2
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Service Providers
                </h2>
                <p
                    style="
                        padding-top: 6pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    We may employ third-party companies and individuals due to
                    the following reasons:
                </p>
                <ul id="l1">
                    <li data-list-text="">
                        <p
                            style="
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            To facilitate our Service;
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-top: 5pt;
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            To provide the Service on our behalf;
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-top: 5pt;
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            To perform Service-related services; or
                        </p>
                    </li>
                    <li data-list-text="">
                        <p
                            style="
                                padding-top: 5pt;
                                padding-left: 41pt;
                                text-indent: -17pt;
                                text-align: left;
                            "
                        >
                            To assist us in analyzing how our Service is used.
                        </p>
                    </li>
                </ul>
                <p
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    We want to inform users of this Service that these third
                    parties have access to your Personal Information. The reason
                    is to perform the tasks assigned to them on our behalf.
                    However, they are obligated not to disclose or use the
                    information for any other purpose.
                </p>
                <h2
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Security
                </h2>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    We value your trust in providing us your Personal
                    Information, thus we are striving to use commercially
                    acceptable means of protecting it. But remember that no
                    method of transmission over the internet, or method of
                    electronic storage is 100% secure and reliable, and we
                    cannot guarantee its absolute security.
                </p>
                <h2
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Links to Other Sites
                </h2>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    This Service may contain links to other sites. If you click
                    on a third-party link, you will be directed to that site.
                    Note that these external sites are not operated by us.
                    Therefore, we strongly advise you to review the Privacy
                    Policy of these websites. We have no control over and assume
                    no responsibility for the content, privacy policies, or
                    practices of any third-party sites or services.
                </p>
                <h2
                    style="
                        padding-top: 3pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Changes to This Privacy Policy
                </h2>
                <p
                    style="
                        padding-top: 5pt;
                        padding-left: 5pt;
                        text-indent: 0pt;
                        line-height: 149%;
                        text-align: left;
                    "
                >
                    We may update our Privacy Policy from time to time. Thus,
                    you are advised to review this page periodically for any
                    changes. We will notify you of any changes by posting the
                    new Privacy Policy on this page. These changes are effective
                    immediately after they are posted on this page.
                </p>
                <h2
                    style="
                        padding-left: 5pt;
                        text-indent: 0pt;
                        text-align: left;
                    "
                >
                    Contact Us
                </h2>
                <p class="s2">
                    If you have any questions or suggestions about our Privacy
                    Policy, do not hesitate to contact us at
                    <a
                        href="mailto:gerdien.simonse@abtexelgroup.com"
                        class="a"
                        target="_blank"
                    >
                        gerdien.simonse@abtexelgroup.com
                    </a>
                    .
                </p>
            </div>
        </div>
    </div>
</ion-content>
